export enum FloorplanPlaceholderPositionKind {
  ALARM_DEVICE = "ALARM_DEVICE",
  PLASTIC_SIGN = "PLASTIC_SIGN",
  SIGNAL_ELEMENT = "SIGNAL_ELEMENT",
  PATIENT_MONITOR = "PATIENT_MONITOR",
  CENTRAL_STATION = "CENTRAL_STATION",
  TELEMETRY = "TELEMETRY",
  TRANSMITTER = "TRANSMITTER",
  GAS_WARNING_CENTER = "GAS_WARNING_CENTER",
  FLAME_DETECTOR = "FLAME_DETECTOR",
  KVM = "KVM",
  DISPLAY = "DISPLAY",
  UTILITY = "UTILITY",
}

export enum FloorplanPlaceholderPositionPrefix {
  ALARM_DEVICE = "PA.",
  PLASTIC_SIGN = "PK.",
  SIGNAL_ELEMENT = "PL.",
  PATIENT_MONITOR = "PM.",
  CENTRAL_STATION = "CS.",
  TELEMETRY = "TM.",
  TRANSMITTER = "PT.",
  FLAME_DETECTOR = "FD.",
  GAS_WARNING_CENTER = "PG.",
  KVM = "KS.",
  DISPLAY = "DS.",
  UTILITY = "UT.",
}
